import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=5dff6020&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dff6020')) {
      api.createRecord('5dff6020', component.options)
    } else {
      api.reload('5dff6020', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=5dff6020&", function () {
      api.rerender('5dff6020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/sidebar/Sidebar.vue"
export default component.exports